var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProvideIncome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 438.03 304.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1uui1125{clip-path:url(#clippath);}.cls-2uui1125,.cls-3uui1125,.cls-4uui1125{fill:none;}.cls-2uui1125,.cls-5uui1125,.cls-6uui1125,.cls-7uui1125{stroke-width:0px;}.cls-3uui1125{stroke-dasharray:0 0 0 6;stroke-linecap:round;stroke-width:2px;}.cls-3uui1125,.cls-4uui1125{stroke:#004f68;stroke-miterlimit:10;}.cls-5uui1125{fill:#c3d9d6;}.cls-6uui1125{fill:#d9c9b1;}.cls-7uui1125{fill:#004f68;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2uui1125",
    d: "m298.09,139.75c0,31.8-18.76,59.23-45.81,71.81-10.12,4.72-21.42,7.35-33.33,7.35-43.71,0-79.15-35.44-79.15-79.16,0-11.91,2.63-23.2,7.35-33.33,12.58-27.05,40-45.81,71.8-45.81,43.71,0,79.15,35.44,79.15,79.15Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2uui1125",
    width: 438.03,
    height: 304.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5uui1125",
    x: 56.44,
    y: 193.39,
    width: 157.86,
    height: 75.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4uui1125",
    x: 63.71,
    y: 202.63,
    width: 143.31,
    height: 56.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4uui1125",
    cx: 135.36,
    cy: 230.92,
    r: 22.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4uui1125",
    cx: 88.55,
    cy: 230.92,
    r: 14.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4uui1125",
    cx: 182.18,
    cy: 230.92,
    r: 14.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5uui1125",
    d: "m252.28,106.41v105.14c-10.12,4.72-21.42,7.35-33.33,7.35-43.71,0-79.15-35.44-79.15-79.16,0-11.91,2.63-23.2,7.35-33.33h105.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1uui1125"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4uui1125",
    cx: 176.28,
    cy: 178.93,
    r: 33.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7uui1125",
    d: "m173.02,202.27c-7.47-.59-12.85-5.38-13.65-13.71h4.52c.54,6.07,3.49,10.75,9.14,11.45v-17.47l-.7-.38c-6.45-3.44-11.02-6.29-11.02-11.99s4.89-9.57,11.72-9.57v-8.06h1.77v8.12c6.56.65,11.07,4.78,12.1,11.4h-4.41c-.59-4.84-3.12-8.44-7.69-9.19v15.7l.64.32c6.99,3.82,11.67,6.61,11.67,12.9s-5.05,10.43-12.31,10.54v8.66h-1.77v-8.71Zm.11-24.62v-14.89h-.05c-4.89-.05-7.58,2.53-7.58,6.34s2.63,5.75,7.63,8.55Zm9.73,15.16c0-4.14-2.58-6.18-8.17-9.3v16.61c4.95-.05,8.17-2.8,8.17-7.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4uui1125",
    x: 130.43,
    y: 125.28,
    width: 103.42,
    height: 111.53
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4uui1125",
    cx: 218.95,
    cy: 139.75,
    r: 79.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3uui1125",
    d: "m97.25,157.88c-1.8-20.57,1.76-41.88,11.42-61.82,28.5-58.79,99.26-83.34,158.05-54.84,58.79,28.5,83.34,99.26,54.84,158.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4uui1125",
    d: "m247.63,80.6c32.67,15.84,46.32,55.16,30.48,87.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4uui1125",
    d: "m164.98,102.2c8.89-12.82,21.83-21.7,36.19-25.74"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4uui1125",
    x1: 291.73,
    y1: 230.92,
    x2: 265.3,
    y2: 203.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6uui1125",
    d: "m306.87,211.76h18.71v84.3c0,2.63-2.13,4.76-4.76,4.76h-9.18c-2.63,0-4.76-2.13-4.76-4.76v-84.3h0Z",
    transform: "translate(-89.33 291.05) rotate(-43.92)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvideIncome);
export default __webpack_public_path__ + "static/media/provide-income.513e4acc5f5b6cf8a36b9b36000f4f76.svg";
export { ForwardRef as ReactComponent };